import { RpeFormScope } from 'src/app/shared/rpe/rpe.model';
import { RPE_INFORMATION_SCREEN_TAB_IDS } from 'src/app/shared/rpe/rpe-information-screen.constants';
import { ActionIcons } from 'src/app/shared/utility/constants';
import {
  RPE_INVALID_TAB_AND_LEGEND_ID,
  rpeTabFormScope,
} from 'src/app/shared/rpe/rpe-module.helper';

export const HAWB_RPE_MODULE = 'Shipment';
export const HAWB_RPE_MODULE_NAMES = [HAWB_RPE_MODULE] as const;

/** Summary Gateway slide-toggle — API `actionName` on Shipment. */
export const HAWB_RPE_ACTION_GATEWAY = 'gateway';

/** Tab / legend ids from SM Roles & Permissions (Shipment information page). */
export const HAWB_RPE_INVALID_TAB_AND_LEGEND_ID = RPE_INVALID_TAB_AND_LEGEND_ID;
export const HAWB_RPE_SHIPPER_LEGEND_ID = 186;
export const HAWB_RPE_CONSIGNEE_LEGEND_ID = 187;
export const HAWB_RPE_SHIPPER_CONSIGNEE_TAB_ID = 124;
export const HAWB_RPE_STATUSCODES_TAB_ID = RPE_INFORMATION_SCREEN_TAB_IDS.statuscodes;
export const HAWB_RPE_ROLES_TAB_ID = 126;
export const HAWB_RPE_MISCELLANEOUS_TAB_ID = RPE_INFORMATION_SCREEN_TAB_IDS.miscellaneous;
export const HAWB_RPE_NOTES_TAB_ID = RPE_INFORMATION_SCREEN_TAB_IDS.notes;
export const HAWB_RPE_ATTACHMENTS_TAB_ID = RPE_INFORMATION_SCREEN_TAB_IDS.attachments;
export const HAWB_RPE_AR_TAB_ID = 130;
export const HAWB_RPE_AP_TAB_ID = 131;

export const HAWB_RPE_SHIPPER_FORM_SCOPE: RpeFormScope = {
  tabId: HAWB_RPE_SHIPPER_CONSIGNEE_TAB_ID,
  legendId: HAWB_RPE_SHIPPER_LEGEND_ID,
};

export const HAWB_RPE_CONSIGNEE_FORM_SCOPE: RpeFormScope = {
  tabId: HAWB_RPE_SHIPPER_CONSIGNEE_TAB_ID,
  legendId: HAWB_RPE_CONSIGNEE_LEGEND_ID,
};

export const HAWB_RPE_STATUSCODES_FORM_SCOPE = rpeTabFormScope(
  HAWB_RPE_STATUSCODES_TAB_ID
);
export const HAWB_RPE_ROLES_FORM_SCOPE = rpeTabFormScope(HAWB_RPE_ROLES_TAB_ID);
export const HAWB_RPE_MISCELLANEOUS_FORM_SCOPE = rpeTabFormScope(
  HAWB_RPE_MISCELLANEOUS_TAB_ID
);
export const HAWB_RPE_NOTES_FORM_SCOPE = rpeTabFormScope(HAWB_RPE_NOTES_TAB_ID);
export const HAWB_RPE_ATTACHMENTS_FORM_SCOPE = rpeTabFormScope(
  HAWB_RPE_ATTACHMENTS_TAB_ID
);
export const HAWB_RPE_AR_FORM_SCOPE = rpeTabFormScope(HAWB_RPE_AR_TAB_ID);
export const HAWB_RPE_AP_FORM_SCOPE = rpeTabFormScope(HAWB_RPE_AP_TAB_ID);

/** Routes tab action fieldNames from loadEffectivePermissions (matched by name, not tab/field id). */
export const HAWB_RPE_ROUTE_ACTION_FIELD_NAMES = {
  configureOwnRoute: 'Configure Own Route',
  choosePreConfigure: 'Choose Pre Configure',
  editTransitPoints: 'Edit Transit Points',
} as const;

/** Single R&P action grants both block and unblock toolbar icons. */
export const HAWB_RPE_BLOCK_UNBLOCK_ACTION = 'block/unblock';

export const HAWB_RPE_ICON_ACTION_OVERRIDES: Record<string, string> = {
  blockShipment: HAWB_RPE_BLOCK_UNBLOCK_ACTION,
  unblock: HAWB_RPE_BLOCK_UNBLOCK_ACTION,
  [ActionIcons.sendInvoice]: 'ar invoice',
  [ActionIcons.generateArInvoice]: 'ar invoice',
  [ActionIcons.gateway]: HAWB_RPE_ACTION_GATEWAY,
};
